// eslint-disable-next-line import/prefer-default-export
export enum PageEnum {
  // basic login path
  BASE_LOGIN = '/login',
  // error page path
  ERROR_PAGE = '/exception',
}
